module.exports = __webpack_public_path__ + "img/icn_confirmation.1d9bb380.svg";